var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorderStyle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.3125C1.375 4.9328 1.6828 4.625 2.0625 4.625H19.9375C20.3172 4.625 20.625 4.9328 20.625 5.3125V6.6875C20.625 7.0672 20.3172 7.375 19.9375 7.375H2.0625C1.6828 7.375 1.375 7.0672 1.375 6.6875V5.3125Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 10.8125C1.375 10.4328 1.6828 10.125 2.0625 10.125H8.9375C9.3172 10.125 9.625 10.4328 9.625 10.8125V12.1875C9.625 12.5672 9.3172 12.875 8.9375 12.875H2.0625C1.6828 12.875 1.375 12.5672 1.375 12.1875V10.8125Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 16.3125C1.375 15.9328 1.6828 15.625 2.0625 15.625H3.4375C3.8172 15.625 4.125 15.9328 4.125 16.3125V17.6875C4.125 18.0672 3.8172 18.375 3.4375 18.375H2.0625C1.6828 18.375 1.375 18.0672 1.375 17.6875V16.3125Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 16.3125C12.375 15.9328 12.6828 15.625 13.0625 15.625H14.4375C14.8172 15.625 15.125 15.9328 15.125 16.3125V17.6875C15.125 18.0672 14.8172 18.375 14.4375 18.375H13.0625C12.6828 18.375 12.375 18.0672 12.375 17.6875V16.3125Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 16.3125C6.875 15.9328 7.1828 15.625 7.5625 15.625H8.9375C9.3172 15.625 9.625 15.9328 9.625 16.3125V17.6875C9.625 18.0672 9.3172 18.375 8.9375 18.375H7.5625C7.1828 18.375 6.875 18.0672 6.875 17.6875V16.3125Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 16.3125C17.875 15.9328 18.1828 15.625 18.5625 15.625H19.9375C20.3172 15.625 20.625 15.9328 20.625 16.3125V17.6875C20.625 18.0672 20.3172 18.375 19.9375 18.375H18.5625C18.1828 18.375 17.875 18.0672 17.875 17.6875V16.3125Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10.8125C12.375 10.4328 12.6828 10.125 13.0625 10.125H19.9375C20.3172 10.125 20.625 10.4328 20.625 10.8125V12.1875C20.625 12.5672 20.3172 12.875 19.9375 12.875H13.0625C12.6828 12.875 12.375 12.5672 12.375 12.1875V10.8125Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderStyle);
export default __webpack_public_path__ + "static/media/border-style.76ed0579f4e2af05396b86fa03212867.svg";
export { ForwardRef as ReactComponent };